<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectQuantity" });
import { SelectSingle } from "../../../../selects/index.js";
import { QUANTITY_RANGES } from "../../config/quantity-ranges.js";
export let key;
export let name = "select-quantity-range";
export let label = "Minimum Quantity";
export let placeholder = "";
export let isDisabled = false;
export let isRequired = false;
export let hint = "";
</script>

<SelectSingle
    bind:key
    {name}
    options={QUANTITY_RANGES}
    {label}
    {placeholder}
    {hint}
    {isDisabled}
    {isRequired}
/>